import { useTranslation } from "react-i18next";
import { useGlobalState } from "../../../components/globalState/GlobalStateProvider";

// Ícone de presente ao lado da opção de consulta coberta por uma degustação ativa. A correspondência é pelo
// identificador da permissão (key do nó da árvore), o mesmo que o backend usa pra consumir o voucher.
// O resumo vem do estado global, alimentado pela TopbarDegustacao. Quem renderiza precisa ter um
// <Tooltip target=".degustacao-icon" /> montado.
export default function DegustacaoIcon({ permissao }: { permissao: string }) {
  const { t } = useTranslation();
  const { state } = useGlobalState();
  const degustacao = (state.degustacoes || []).find((d) => d.permissao === permissao);
  if (!degustacao) return null;
  return (
    <i className="degustacao-icon pi pi-gift" data-pr-tooltip={`${t('degustacao')}: ${degustacao.restante} ${t('consultasRestantes')}`}
      data-pr-position="right" style={{ paddingLeft: '0.5rem', color: '#183462', fontSize: '1.1rem', verticalAlign: 'middle' }} />
  );
}
